<template>
    <div>
        <audit
            v-if="auditSelected"
            :audit="auditSelected"
            v-on:new-template="onSaveTemplate">
        </audit>
    </div>
</template>

<script>
    import { API, graphqlOperation } from 'aws-amplify'
    import { createAuditTemplate, createChecklistTemplate } from '@/graphql/mutations'
    import Audit from '@/components/Audit.vue'
    import { mapState } from 'vuex'
    import v4 from 'uuid'


    export default {
        data() {
            return {

            }
        },
        computed: mapState({
            auditSelected: state => state.currentAudit.header
        }),
        components: {
            'audit': Audit
        },
        methods: {
            loadAudit() {
                let auditSelected = this.auditSelected
                let auditId = this.$route.params.auditId
                if (!auditSelected || auditSelected.id != auditId) {
                    this.$store.dispatch('currentAudit/setCurrent', { id: auditId })
                }
            },
            reloadAudit() {
                let audit = this.auditSelected
                if (!audit) {
                    audit = { id: this.$route.params.auditId }
                }
                console.log("reloading audit", audit)
                if (audit) {
                    this.$store.dispatch('currentAudit/setCurrent', audit)
                }
            },
            createChecklistTemplate: function(checklist, auditId, checklistParentId) {
                let questions = []
                if (checklist.questions) {
                    questions = checklist.questions.map(q => {
                        return {
                            'auditCode': q.auditCode,
                            'desc': q.desc
                        }
                    })
                }

                let id = v4()
                let checklistTemp = {
                    'id': id,
                    'auditCode': checklist.auditCode,
                    'desc': checklist.desc,
                    'questions': questions,
                }
                if (auditId)
                    checklistTemp['auditTemplateChecklistsId'] = auditId
                if (checklistParentId)
                    checklistTemp['checklistTemplateSublistsId'] = checklistParentId

                return {
                    template: checklistTemp,
                    'sublists': checklist.sublists ? checklist.sublists.map(s => this.createChecklistTemplate(s, null, id)) : []
                }
            },
            onSaveTemplate: async function(templateInfo) {
                console.log("Checklist template", templateInfo)
                let template = {
                    'name': templateInfo.name,
                    'desc': templateInfo.desc.trim().length > 0 ? templateInfo.desc : null,
                }
                try {
                    let { data } = await API.graphql(graphqlOperation(createAuditTemplate, { input: template }))
                    console.log("returned data was", data.createAuditTemplate)

                    let saveChecklists = templateInfo.audit.checklists.map(c => {
                        return this.createChecklistTemplate(c, data.createAuditTemplate.id)
                    })
                    let savePromises = this.saveSublists(saveChecklists)

                    savePromises.forEach(async function(p) {
                        await p
                    })
                }
                catch (err) {
                    console.log('error saving audit template', err, templateInfo)
                }
            },
            saveSublists(checklists) {
                let promises = []
                checklists.forEach(c => {
                    promises.push(API.graphql(graphqlOperation(createChecklistTemplate, { input: c.template })))
                    if (c.sublists) {
                        let subPromises = this.saveSublists(c.sublists)
                        console.log("sub promises", subPromises)
                        promises.push(...subPromises)
                    }
                })
                return promises
            }
        },
        watch: {
            $route: 'loadAudit'
        },
        created() {
            this.loadAudit()
        }
    }
</script>
